<template>
  <div class="PostponeShipment">
    <p class="Tips">
      {{ $t('subscription_details.replenishment.postpone.confirmText', 'Would you like to postpone your next shipment by 1 month') }}
    </p>

    <app-button
      type="submit"
      @click.prevent="onSubmitButtonClicked"
      :is-loading="postponeReplenishmentTask.isActive"
      data-name="postponeReplenishment-submitButton"
    >
      {{ $t('subscription_details.replenishment.postpone.button', 'Postpone by 1 month') }} ›
    </app-button>

    <app-modal name="replenishmentPostpone" width="500">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.replenishment.postpone.confirmationModal.title', 'Postphone next shipment') }}
        </h3>

        <div class="modal-content">
          <p>
            {{ $t('subscription_details.replenishment.postpone.confirmationModal.text', 'Are you sure you postpone your next shipment by 1 month ?') }}
          </p>

          <div class="modal-button-warpper">
            <app-button
              type="submit"
              @click.prevent="postponeReplenishmentTask.run()"
            >
              {{ $t('subscription_details.replenishment.postpone.confirmationModal.button.ok', 'Ok') }}
            </app-button>

            <app-button @click.prevent="onModalCancelled">
              {{ $t('subscription_details.replenishment.postpone.confirmationModal.button.cancel', 'Cancel') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'replenishment-postpone',

    props: {
      subscriptionNumber: {
        type: String,
        required: true
      },

      subscriptionRatePlanId: {
        type: String,
        required: true
      }
    },

    tasks (t) {
      return {
        postponeReplenishmentTask: t(async function () {
          this.$bus.$emit('close-modal', 'replenishmentPostpone')
          this.trackConversion({ name: 'interaction', description: 'popup:postphone_shipment:ok' })
          await Vue.api.subscription.postponeReplenishment(this.subscriptionNumber)

          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)

          this.$notify({
            type: 'success',
            title: this.$t('popuptips.postponeReplenishment.request.sent', 'The replenishment has been postponed successfully!')
          })
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        }).flow('drop')
      }
    },

    methods: {
      onModalCancelled () {
        this.trackConversion({ name: 'interaction', description: 'popup:postphone_shipment:cancel' })
        this.$bus.$emit('close-modal', 'replenishmentPostpone')
      },

      onSubmitButtonClicked () {
        this.trackConversion({ name: 'interaction', description: 'postpone_shipment' })
        this.trackConversion({ name: 'interaction', description: 'postphone_shipment:button:submit' })
        this.$bus.$emit('open-modal', 'replenishmentPostpone')
      }
    }
  }
</script>
